import { backdropClasses } from '@mui/material/Backdrop';
import { Dialog, styled } from '@mui/material';
import { dialogClasses } from '@mui/material/Dialog';

const StyledSessionDetailsDialog = styled(Dialog)(({ theme }) => ({
  [`& .${backdropClasses.root}`]: {
    backgroundColor: theme.palette.scrim
  },
  [`& .${dialogClasses.paper}`]: {
    backgroundColor: theme.palette.gray3.main,
    backgroundImage: 'none',
    borderRadius: '8px',
    boxShadow: theme.palette.shadow.menu,
    padding: `0 ${theme.spacing(1.5)} ${theme.spacing(1.5)}`,
    [theme.breakpoints.up('md')]: {
      borderRadius: '10px'
    }
  }
}));

export default StyledSessionDetailsDialog;
